module.exports = __webpack_public_path__ + "static/img/ent-9.a32fb56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-9.jpg
// module id = mtQI
// module chunks = 52